import { user, User } from 'utils/auth/user';

export const applyUserTheme = () => {
  const wcElement = document.querySelector('ex3d-app');
  if (!wcElement) {
    console.warn('Element not found, cannot apply theme');
    return;
  }

  if (!isUserInfoAvailable()) {
    // Keep default ex3d-customer class if we can't determine user type
    console.warn('Unable to determine user type, keeping default customer class');
    return;
  }

  // User info is available, so update the class if needed
  if (user.isDealer) {
    wcElement.classList.remove('ex3d-customer');
    wcElement.classList.add('ex3d-dealer');
  }
};

/**
 * Check if user configuration callbacks are set and user info is available.
 */
const isUserInfoAvailable = (): boolean => {
  if (!User.config.getUserInfoCallback) {
    return false;
  }

  const userInfo = user.getUserInfo();
  return userInfo !== null && userInfo !== undefined && !!userInfo.type;
};
